module.exports = __webpack_public_path__ + "static/media/mail1.9a65add1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/mail1.svg
// module id = 837
// module chunks = 21